export type IframeScenario = 'BizChatSidebar' | 'HelpPane' | 'RewardsPane';

export type ScenarioSettings = {
    matchUrl: (url: string) => boolean;
    enablePreloading: boolean;
    enableCaching: boolean;
};

const defaultSettings: Omit<ScenarioSettings, 'matchUrl'> = {
    enablePreloading: false,
    enableCaching: false,
};

export const iframesMapping: Record<IframeScenario, ScenarioSettings> = {
    BizChatSidebar: {
        ...defaultSettings,
        matchUrl: (url: string) =>
            url.includes('/hosted/semanticoverview/') || url.includes('m365copilotapp'),
        enablePreloading: true,
        enableCaching: true,
    },
    HelpPane: {
        ...defaultSettings,
        matchUrl: (url: string) => url.includes('https://cjs.diagnostics.office.com/support'),
    },
    RewardsPane: {
        ...defaultSettings,
        matchUrl: (url: string) => url.includes('rewards/panelflyout'),
    },
};
